module.exports = __webpack_public_path__ + "img/zgh.f43bf9ee.png";